import { useTranslation } from 'react-i18next';
import Constants from '~/app/Constants';
import Configuration from './Configuration';

export function GetCopyrightTranslation(): string {
  const year = new Date().getFullYear();
  const { t } = useTranslation('App');
  const dealersCopyrightExperiences = {
    hyundai: 'CopyrightHyundai',
    unifi: 'CopyrightUnifi',
    genesis: 'CopyrightGenesis',
    honda: 'CopyrightHonda',
    acura: 'CopyrightAcura',
  };
  const copyrightKey = dealersCopyrightExperiences[GetDealersExperience() as keyof typeof dealersCopyrightExperiences];
  const copyright = t(copyrightKey, { year });
  return copyright;
}

export function GetTitleTranslationKey(): string {
  const dealersTitleKey = {
    unifi: 'UnifiTitle',
    acura: 'AcuraTitle',
    honda: 'HondaTitle',
    hyundai: 'HyundaiTitle',
    genesis: 'GenesisTitle',
  };

  return dealersTitleKey[GetDealersExperience() as keyof typeof dealersTitleKey];
}

export function GetDealersExperience(): string {
  let dealersExperience = sessionStorage.getItem('dealersExperience');
  if (!dealersExperience) {
    dealersExperience = Constants.DealersExperience.unifi;
    SetDealersExperience(dealersExperience);
  }

  const uri = window.location.href;
  const searchTerms = ['bookmark/', 'sso/saml2/'];

  for (let i = 0; i < searchTerms.length; i++) {
    // searchTerms.forEach((searchTerm) => {
    if (uri.includes(searchTerms[i])) {
      const indexOfClientId = uri.indexOf(searchTerms[i]) + searchTerms[i].length;
      const indexOfClientIdEnd = uri.indexOf('/', indexOfClientId + 1) <= 0
        ? uri.indexOf('?', indexOfClientId + 1)
        : uri.indexOf('/', indexOfClientId + 1);
      const oktaClientId = indexOfClientIdEnd <= 0
        ? uri.substring(indexOfClientId)
        : uri.substring(indexOfClientId, indexOfClientIdEnd);

      const storedOktaClientId = sessionStorage.getItem(`oktaClientId_${searchTerms[i]}`);

      if (oktaClientId !== storedOktaClientId) {
        const config = Configuration.Current();
        switch (oktaClientId) {
          case config.oktaBookmarkClientIdAcura:
          case config.oktaBookmarkClientIdAcuraSSO:
            dealersExperience = Constants.DealersExperience.acura;
            break;
          case config.oktaBookmarkClientIdGenesis:
          case config.oktaBookmarkClientIdGenesisSSO:
            dealersExperience = Constants.DealersExperience.genesis;
            break;
          case config.oktaBookmarkClientIdHonda:
          case config.oktaBookmarkClientIdHondaSSO:
            dealersExperience = Constants.DealersExperience.honda;
            break;
          case config.oktaBookmarkClientIdHyundai:
          case config.oktaBookmarkClientIdHyundaiSSO:
            dealersExperience = Constants.DealersExperience.hyundai;
            break;
          default:
            dealersExperience = Constants.DealersExperience.unifi;
        }
        SetDealersExperience(dealersExperience);
        sessionStorage.setItem(`oktaClientId_${searchTerms[i]}`, oktaClientId);
        break;
      }
    }
  }
  return dealersExperience;
}

export function SetDealersExperience(dealerExperience: string) {
  sessionStorage.setItem('dealersExperience', dealerExperience !== null ? dealerExperience : Constants.DealersExperience.unifi);
}

export function DisplayBody() {
  document.body.style.display = 'None';
  const uri = window.location.href;
  const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const config = Configuration.Current();
  const searchTerms = ['bookmark/', 'sso/saml2/', 'oauth2/', 'idp/authenticators/', config.oktaClientIdUnifi, config.oktaObjectIdPPM];
  if (isLocalHost || searchTerms.some((term) => uri.toLowerCase().includes(term.toLowerCase()))) {
    document.body.style.display = 'Block';
  }
}
